import { ServerInterface } from "../interfaces/Server.interface";
import { BLANK_ORGANIZATION } from "./organization";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_SERVER: ServerInterface = {
	id: "",
	ip: "",
	name: "",
	sync_sched: "",
	org_id: "",
	record_sync_size: 0,
	org: BLANK_ORGANIZATION,
	channels: [],
	next_records_sync_run: "",
	next_server_sync_run: "",
	fb_enabled: true,
	last_successful_quest_db_sync_run: null,
	next_quest_db_sync_run: null,
	sync_quest_db_sched: "",
	active: true,
};
